import type { GetServerSideProps } from "next";

import { loadPageWithGlobal } from "@shared/api";

import { EventPage } from "@/_pages/event";
import { getEventPage } from "@/_pages/event/api/getEventPage";
import type { EventPageType } from "@/_pages/event/model";

type PageProps = {
  cms: EventPageType;
};

type Params = {
  slug: string;
};

const Page = ({ cms }: PageProps) => {
  return <EventPage event={cms.event} comingEvents={cms.comingEvents} />;
};

export const getServerSideProps: GetServerSideProps<{}, Params> = async (
  context,
) => {
  const { res } = context;
  const { slug } = context.params!;

  return await loadPageWithGlobal(
    async () => {
      const { event, comingEvents } = await getEventPage(slug);

      return {
        event,
        comingEvents,
      };
    },
    { res },
  );
};

export default Page;
